"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

exports.SecondaryLabel = styled_components_1.default.span(function (_a) {
  var active = _a.active,
      theme = _a.theme;
  var radioTheme = theme.components.radio;
  return {
    color: active ? radioTheme.selected.color : radioTheme.secondaryLabel.color
  };
});
exports.ButtonRadioWrapper = styled_components_1.default.div(function (_a) {
  var theme = _a.theme,
      orientation = _a.orientation;
  return {
    display: 'flex',
    flexDirection: orientation === 'vertical' ? 'column' : 'row',
    listStyle: 'none'
  };
});
exports.BaseButtonRadioOption = styled_components_1.default.div(function (_a) {
  var theme = _a.theme,
      active = _a.active;
  var radioTheme = theme.components.radio;
  return {
    borderLeft: radioTheme.default.borderWidth + " solid " + (active ? radioTheme.selected.borderColor : radioTheme.default.borderColor),
    borderTop: radioTheme.default.borderWidth + " solid " + (active ? radioTheme.selected.borderColor : radioTheme.default.borderColor),
    backgroundColor: active ? radioTheme.selected.backgroundColor : radioTheme.default.backgroundColor,
    color: active ? radioTheme.selected.color : radioTheme.default.color,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    fontFamily: theme.fontText,
    height: radioTheme.default.height,
    padding: "0px " + radioTheme.default.padding,
    ':hover': {
      backgroundColor: active ? radioTheme.selected.backgroundColor : radioTheme.hover.backgroundColor,
      shadow: radioTheme.hover.shadow,
      color: radioTheme.hover.color
    }
  };
});
exports.HorizontalButtonRadioOption = styled_components_1.default(exports.BaseButtonRadioOption)(function (_a) {
  var theme = _a.theme,
      active = _a.active;
  var radioTheme = theme.components.radio;
  return {
    ':first-child': {
      borderBottomLeftRadius: theme.radius,
      borderTopLeftRadius: theme.radius
    },
    ':last-child': {
      borderBottomRightRadius: theme.radius,
      borderRight: radioTheme.default.borderWidth + "  solid " + (active ? theme.border.active : theme.border.default),
      borderTopRightRadius: theme.radius
    },
    '+ div': {
      borderLeft: active ? radioTheme.default.borderWidth + "  solid " + theme.border.active : ''
    },
    borderBottom: radioTheme.default.borderWidth + "  solid " + (active ? theme.border.active : theme.border.default)
  };
});
exports.VerticalButtonRadioOption = styled_components_1.default(exports.BaseButtonRadioOption)(function (_a) {
  var theme = _a.theme,
      active = _a.active;
  var radioTheme = theme.components.radio;
  return {
    ':first-child': {
      borderTopRightRadius: theme.radius,
      borderTopLeftRadius: theme.radius
    },
    ':last-child': {
      borderBottomRightRadius: theme.radius,
      borderBottomLeftRadius: theme.radius,
      borderBottom: radioTheme.default.borderWidth + "  solid " + (active ? theme.border.active : theme.border.default)
    },
    '+ div': {
      borderTop: active ? radioTheme.default.borderWidth + " solid " + theme.border.active : ''
    },
    borderRight: radioTheme.default.borderWidth + "  solid " + (active ? theme.border.active : theme.border.default)
  };
});